var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 22 28.18",
    style: {
      enableBackground: "new 0 0 22 28.18"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#0A499A;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M16.64,7.24c-0.69,0-1.25,0.56-1.25,1.25c0,0.69,0.56,1.25,1.25,1.25c0.69,0,1.25-0.56,1.25-1.25 C17.89,7.8,17.33,7.24,16.64,7.24z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M11.09,8.84c-2.89,0-5.25,2.35-5.25,5.25c0,2.89,2.35,5.25,5.25,5.25c2.89,0,5.25-2.35,5.25-5.25 C16.34,11.2,13.98,8.84,11.09,8.84z M11.09,17.45c-1.85,0-3.36-1.51-3.36-3.36s1.51-3.36,3.36-3.36c1.85,0,3.36,1.51,3.36,3.36 S12.94,17.45,11.09,17.45z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M15.25,24.75H6.74c-3.53,0-6.4-2.87-6.4-6.4V9.83c0-3.53,2.87-6.4,6.4-6.4h8.51c3.53,0,6.4,2.87,6.4,6.4v8.51 C21.66,21.87,18.78,24.75,15.25,24.75z M6.74,5.44c-2.42,0-4.4,1.97-4.4,4.4v8.51c0,2.42,1.97,4.4,4.4,4.4h8.51 c2.42,0,4.4-1.97,4.4-4.4V9.83c0-2.42-1.97-4.4-4.4-4.4H6.74z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.53f7e517ab022ed548b1952a5099e1ff.svg";
export { ForwardRef as ReactComponent };